import React, { useEffect, useState } from "react";
import classes from "./CategoriesPage.module.css";
import Layout from "../components/newComponents/Layout";
import Card from "../components/newComponents/Card";
import CardHeader from "../components/newComponents/CardHeader";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import dictionaryCategories from "../database/categories";
import { resetCategoryTargetWord, setCategoryTargetWord } from "../slices/categoriesSlice/categorySlice";
import {
  deleteCategoryWord,
  resetCategoryWord,
  updateCategoryWord,
} from "../slices/categoriesSlice/categoryWordSlice";
import { resetCategoryResult, setCategoryResult } from "../slices/categoriesSlice/categoryWordResult";
import CryptoJS from "crypto-js";
import CategoriesGameOverModal from "../components/CategoriesGameOverModal";

const decryptData = (encryptedData) => {
  const decryptedData = CryptoJS.AES.decrypt(
    encryptedData,
    "my little secret"
  ).toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedData);
};

const CategoriesPage = () => {
  const { category } = useParams();
  const dispatch = useDispatch();
  const [enterPressed, setEnterPressed] = useState(false);
  const [originalWord, setOriginalWord] = useState("");

  const [modalOpen, setModalOpen] = useState(false);
  const [winType, setWinType] = useState("");

  const categories = useSelector((state) => state.categorySlice);
  const { categoryWord } = useSelector((state) => state.categoryWordSlice);
  const { categoryWordResult } = useSelector(
    (state) => state.categoryWordResult
  );
  console.log(categories, "c");
  console.log(categoryWord, "cw");
  console.log(categoryWordResult, "categoryWordResult");

  useEffect(() => {
    if (!categories?.categoryTargetWord) {
      let filteredData = dictionaryCategories?.filter(
        (data) => data?.category == category
      );
      console.log(filteredData, "filteredData");
      dispatch(
        setCategoryTargetWord(filteredData[0]?.name[categories?.categoryLevel])
      );
    }
  }, [categories]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      // check if the entered word is correct or not...
      if (
        [...categories?.shuffleCategoryTargetWord].length == categoryWord.length
      ) {
        setEnterPressed(true);

        setTimeout(() => {
          setEnterPressed(false);
        }, 1000);
        console.log("check now");
        dispatch(
          setCategoryResult({
            targetWord: categories?.categoryTargetWord,
            enteredWord: categoryWord,
          })
        );
      }
    }

    if (event.key === "Backspace" || event.key === "Delete") {
      deleteKey();
      return;
    }

    if (event.key.match(/^[a-z]$/)) {
      pressKey(event.key);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  const deleteKey = () => {
    // erase the one letter...
    if (categoryWord?.length > 0) {
      dispatch(deleteCategoryWord());
    }
  };

  const pressKey = (key) => {
    // add the letter to slice
    if (
      categoryWord.length < [...categories?.shuffleCategoryTargetWord].length
    ) {
      console.log("update the word in slice...");
      dispatch(updateCategoryWord(key));
    }
  };

  useEffect(() => {
    if (categoryWordResult == true) {
      console.log("true correct answer...");
      let word = decryptData(categories?.categoryTargetWord);
      setOriginalWord(word);
      setModalOpen(true);
      setWinType(1);
    } else if (categoryWordResult == false) {
      let word = decryptData(categories?.categoryTargetWord);
      setOriginalWord(word);
      setModalOpen(true);
      setWinType(0);
    }
  }, [pressKey]);

  const nextLevelHandler=()=>{
    setModalOpen(false);
    setWinType("");
    dispatch(resetCategoryResult());
    dispatch(resetCategoryTargetWord());
    dispatch(resetCategoryWord());
  }

  const closeModalHandler=()=>{
    setModalOpen(false);
    setWinType("");
    dispatch(resetCategoryResult());
    dispatch(resetCategoryTargetWord());
    dispatch(resetCategoryWord());
  }


  return (
    <>
      <Layout>
        <Card>
          <CardHeader title={`Guess the ${category}`} />

          <div className={classes.word}>
            <p className={classes.shuffled_word}>
              Level: {categories?.categoryLevel + 1}
            </p>
          </div>

          <div className={classes.word}>
            <p className={classes.shuffled_word}>
              {categories?.shuffleCategoryTargetWord}
            </p>
          </div>

          <div
            className={classes.tiles_grid}
            style={{
              gridTemplateColumns: `repeat(${
                [...categories?.shuffleCategoryTargetWord].length
              },5rem)`,
            }}
          >
            {[...categories?.shuffleCategoryTargetWord].map((char, index) => (
              <div
                key={index}
                className={`${classes.tile}
            ${enterPressed && classes.flip_tile}
            `}
              >
                {categoryWord[index]}
              </div>
            ))}
          </div>
        </Card>

        <div className={classes.keyboard_container}>
          <div className={classes.keypad_1}>
            <div className={classes.key} onClick={() => pressKey("Q")}>
              Q
            </div>
            <div className={classes.key} onClick={() => pressKey("W")}>
              W
            </div>
            <div className={classes.key} onClick={() => pressKey("E")}>
              E
            </div>
            <div className={classes.key} onClick={() => pressKey("R")}>
              R
            </div>
            <div className={classes.key} onClick={() => pressKey("T")}>
              T
            </div>
            <div className={classes.key} onClick={() => pressKey("Y")}>
              Y
            </div>
            <div className={classes.key} onClick={() => pressKey("U")}>
              U
            </div>
            <div className={classes.key} onClick={() => pressKey("I")}>
              I
            </div>
            <div className={classes.key} onClick={() => pressKey("O")}>
              O
            </div>
            <div className={classes.key} onClick={() => pressKey("P")}>
              P
            </div>
          </div>
          <div className={classes.keypad_2}>
            <div className={classes.key} onClick={() => pressKey("A")}>
              A
            </div>
            <div className={classes.key} onClick={() => pressKey("S")}>
              S
            </div>
            <div className={classes.key} onClick={() => pressKey("D")}>
              D
            </div>
            <div className={classes.key} onClick={() => pressKey("F")}>
              F
            </div>
            <div className={classes.key} onClick={() => pressKey("G")}>
              G
            </div>
            <div className={classes.key} onClick={() => pressKey("H")}>
              H
            </div>
            <div className={classes.key} onClick={() => pressKey("J")}>
              J
            </div>
            <div className={classes.key} onClick={() => pressKey("K")}>
              K
            </div>
            <div className={classes.key} onClick={() => pressKey("L")}>
              L
            </div>
          </div>
          <div className={classes.keypad_3}>
            <div
              className={classes.key_large}
              onClick={() => handleKeyDown({ key: "Enter" })}
            >
              ENTER
            </div>
            <div className={classes.key} onClick={() => pressKey("Z")}>
              Z
            </div>
            <div className={classes.key} onClick={() => pressKey("X")}>
              X
            </div>
            <div className={classes.key} onClick={() => pressKey("C")}>
              C
            </div>
            <div className={classes.key} onClick={() => pressKey("V")}>
              V
            </div>
            <div className={classes.key} onClick={() => pressKey("B")}>
              B
            </div>
            <div className={classes.key} onClick={() => pressKey("N")}>
              N
            </div>
            <div className={classes.key} onClick={() => pressKey("M")}>
              M
            </div>
            <div className={classes.key_large} onClick={deleteKey}>
              Backspace
            </div>
          </div>
        </div>
      </Layout>
      {modalOpen && (
        <CategoriesGameOverModal
            closeModalHandler={closeModalHandler}
            nextLevelHandler={nextLevelHandler}
          winType={winType}
          originalWord={originalWord}
          setModalOpen={setModalOpen}
        />
      )}
    </>
  );
};

export default CategoriesPage;



// NEXT LEVEL LOGIC IS LEFT AND CLEARING THE STORE IS LEFT ....
